<template>
	<svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M30.1858 15.0929C30.1858 6.75502 23.4251 0 15.0929 0C6.75502 0 0 6.75502 0 15.0929C0 22.6243 5.5174 28.869 12.7346 30V19.4567H8.90199V15.0939H12.7346V11.7668C12.7346 7.9851 14.9844 5.89661 18.4332 5.89661C20.0849 5.89661 21.814 6.19093 21.814 6.19093V9.90473H19.9076C18.036 9.90473 17.4512 11.0697 17.4512 12.263V15.0929H21.6366L20.9641 19.4557H17.4512V29.9991C24.6628 28.868 30.1858 22.6233 30.1858 15.092V15.0929Z" :fill="color"/>
	</svg>
</template>

<script>
export default {
	name: 'IconFacebookRound',
	props: {
		color: {
			type: String,
			default: '#4B4B4B'
		}
	}
}
</script>
